// @ts-nocheck

import palette from '../palette';

export const Cgu = {
  acceptBackgroundColor: palette.red200,
  acceptColor: palette.white,
  backgroundColor: palette.bluegrey850,
  rejectBackgroundColor: palette.bluegrey700,
  rejectColor: palette.white,
};
